import { HR } from 'foundations-components/transitional/components/HR';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import Raven from 'raven-js';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { noPortalFetchApplicationAuthorizationData } from '../actions/AppActions';
import { getAuthorizationRequestInfo, getSelectedAccountUrl } from '../utils/urls';
import AppInfoTitle from './AppInfoTitle';
import EnterpriseOnlyAlert from './EnterpriseOnlyAlert';
import { MaxWidthContainer } from './MaxWidthContainer';
import AccountPicker from './accountPickerComponents/AccountPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const INCLUDED_APPS = {
  OKTA_SCIM_QA: 1204574,
  OKTA_SCIM_PROD: 233741
};
const ConnectAppInfo = ({
  providerDomain,
  providerName,
  providerId,
  accounts
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedAccount, setSelectedAccount] = useState(null);
  const showEnterpriseWarning = [INCLUDED_APPS.OKTA_SCIM_QA, INCLUDED_APPS.OKTA_SCIM_PROD].includes(providerId);
  const selectAccount = account => {
    if (showEnterpriseWarning) {
      const authRequestInfo = getAuthorizationRequestInfo(location.search);
      setSelectedAccount(account);
      dispatch(noPortalFetchApplicationAuthorizationData({
        data: Object.assign({}, authRequestInfo, {
          hublet: account.hublet,
          hubId: account.portalId
        })
      })).catch(e => Raven.captureException(e));
      return;
    }
    window.location.href = getSelectedAccountUrl({
      portalId: account.portalId,
      hublet: account.hublet,
      search: location.search
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showEnterpriseWarning && /*#__PURE__*/_jsx(EnterpriseOnlyAlert, {
      location: location,
      providerName: providerName,
      selectedAccount: selectedAccount
    }), /*#__PURE__*/_jsx(MaxWidthContainer, {
      children: /*#__PURE__*/_jsx(Tile, {
        marginBlockStart: "600",
        marginInline: "200",
        children: /*#__PURE__*/_jsxs(TileSection, {
          children: [/*#__PURE__*/_jsx("span", {
            "data-test-id": "authorize-title",
            children: /*#__PURE__*/_jsx(AppInfoTitle, {
              providerDomain: providerDomain,
              providerName: providerName,
              appId: providerId
            })
          }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(AccountPicker, {
            accounts: accounts,
            selectAccount: selectAccount,
            appName: providerName
          })]
        })
      })
    })]
  });
};
export default ConnectAppInfo;